// OpenAI Ads Measurement Pixel, gated by Shopify processing permissions.
(() => {
  if (window.rmOpenAIAdsLoaded) return;
  window.rmOpenAIAdsLoaded = true;

  const config = JSON.parse(document.getElementById('rm-openai-ads-config').textContent);
  let initialized = false;
  let viewed = false;

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true &&
      (!config.user || privacy?.saleOfDataAllowed() === true);
  }

  function measure(name, data) {
    try {
      if (!initialized || !allowed()) return;
      window.oaiq('measure', name, data, {
        opt_out: window.Shopify.customerPrivacy.saleOfDataAllowed() !== true,
      });
    } catch {}
  }

  function updateConsent() {
    try {
      const permitted = allowed();
      if (!permitted) {
        if (initialized) window.oaiq('consent', false);
        return;
      }
      if (!initialized) {
        if (window.oaiq) return;
        const queue = function () { queue.q.push(arguments); };
        queue.q = [];
        window.oaiq = queue;
        window.oaiq('consent', true);
        const options = { pixelId: config.pixelId };
        if (config.user) options.user = config.user;
        window.oaiq('init', options);
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        document.head.appendChild(script);
        initialized = true;
      } else {
        window.oaiq('consent', true);
      }
      if (!viewed) {
        viewed = true;
        measure('page_viewed', { type: 'contents' });
        if (config.productId) {
          measure('contents_viewed', {
            type: 'contents',
            contents: [{ id: config.productId, content_type: 'product' }],
          });
        }
      }
    } catch {}
  }

  document.addEventListener('cart:update', (event) => {
    try {
      const detail = event.detail;
      const data = detail?.data;
      if (data?.source !== 'product-form-component' || data.didError) return;
      const id = detail.sourceId;
      const quantity = Number(data.itemCount);
      if (!id || !Number.isInteger(quantity) || quantity <= 0) return;
      measure('items_added', {
        type: 'contents',
        contents: [{ id: String(id), content_type: 'product', quantity }],
      });
    } catch {}
  });

  document.addEventListener('visitorConsentCollected', updateConsent);
  try {
    if (window.Shopify?.customerPrivacy) updateConsent();
    else window.Shopify?.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) updateConsent();
    });
  } catch {}
})();
